<template>
    <div class="container">
        <header_auth title="忘记密码"/>
        <div class="w clearfix">
            <white-space />
            <white-space />

            <div class="step">
                <el-steps :space="200" :active="step" finish-status="success" align-center>
                    <el-step title="验证手机号码"></el-step>
                    <el-step title="设置密码"></el-step>
                    <el-step title="修改成功"></el-step>
                </el-steps>
            </div>

            <el-form ref="form" :model="form" label-width="0" class="form" :rules="rules">
                <template v-if="step === 0">
                    <el-form-item prop="mobile">
                        <el-input v-model="form.mobile" placeholder="请填写手机号码">
                            <i slot="prepend" class="el-icon-mobile-phone form-label-icon"></i>
                        </el-input>
                    </el-form-item>

                    <el-form-item v-show="form.mobile">
                        <div class="nc-container" id="nc-container"></div>
                    </el-form-item>

                    <el-form-item> 已有账号？<router-link to="/login" class="active">直接登录</router-link> </el-form-item>
                </template>

                <template v-if="step === 1">
                    <el-form-item prop="captcha_sms">
                        <el-input v-model="form.captcha_sms" placeholder="请输入短信验证码" autocomplete="off">
                            <i slot="prepend" class="el-icon-mobile-phone form-label-icon"></i>
                        </el-input>
                    </el-form-item>

                    <el-form-item prop="password">
                        <el-input v-model="form.password" placeholder="请设置登录密码" type="password" autocomplete="off">
                            <i slot="prepend" class="el-icon-lock form-label-icon"></i>
                        </el-input>
                    </el-form-item>

                    <el-form-item prop="comfirmpwd">
                        <el-input v-model="form.comfirmpwd" placeholder="请确认登录密码" type="password" autocomplete="off">
                            <i slot="prepend" class="el-icon-lock form-label-icon"></i>
                        </el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button
                            class="btn-signup"
                            type="primary"
                            @click="onSubmit"
                            :loading="submitting"
                            :disabled="!form.mobile || !form.password || !form.captcha || !form.captcha_sms || !form.comfirmpwd"
                        >
                            提交
                        </el-button>
                    </el-form-item>
                </template>

                <template v-if="step === 3">
                    <div class="success">
                        <i class="el-icon-circle-check icon"></i>
                        密码修改成功，请重新登录...
                    </div>
                </template>

                <white-space />
                <white-space />
            </el-form>
        </div>
        <global-footer />
    </div>
</template>

<script>
    import header_auth from "../components/header_auth";

    export default {
        data() {
            const validateMobile = (rule, value, callback) => {
                if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(value)) {
                    callback(new Error("手机号码格式错误"));
                } else {
                    callback();
                }
            };

            const validatePwd = (rule, value, callback) => {
                if (value != this.form.password) {
                    callback(new Error("确认密码与密码不一致"));
                } else {
                    callback();
                }
            };

            return {
                submitting: false,
                form: {
                    mobile: "",
                    password: "",
                    captcha: "",
                    comfirmpwd: "",
                },
                step: 0,
                disabled: false,
                captcha_src: "",
                comfirmpwd: "",
                checked: true,
                time: "",
                rules: {
                    mobile: [
                        {
                            required: true,
                            message: "请输入手机号码",
                            trigger: "blur",
                        },
                        {
                            validator: validateMobile,
                            trigger: "blur",
                        },
                    ],
                    password: [
                        {
                            required: true,
                            message: "请输入密码",
                            trigger: "blur",
                        },
                        {
                            min: 6,
                            max: 15,
                            message: "长度在 6 到 15 个字符",
                            trigger: "blur",
                        },
                    ],
                    captcha: [
                        {
                            required: true,
                            message: "请输入图片验证码",
                            trigger: "blur",
                        },
                    ],
                    captcha_sms: [
                        {
                            required: true,
                            message: "请输入短信验证码",
                            trigger: "blur",
                        },
                    ],
                    comfirmpwd: [
                        {
                            required: true,
                            message: "请输入确认密码",
                            trigger: "blur",
                        },
                        {
                            min: 6,
                            max: 15,
                            message: "长度在 6 到 15 个字符",
                            trigger: "blur",
                        },
                        {
                            validator: validatePwd,
                            trigger: "blur",
                        },
                    ],
                },
                countDown: 0,
            };
        },
        created() {
            this.time = 60;
            localStorage.getcaptcha_sms = true;
        },
        components: { header_auth },
        mounted() {
            //验证码
            var nc_token = ["FFFF0N0N000000008717", new Date().getTime(), Math.random()].join(":");
            var NC_Opt = {
                renderTo: "#nc-container",
                appkey: "FFFF0N0N000000008717",
                scene: "nc_login",
                token: nc_token,
                customWidth: 415,
                trans: { key1: "code0" },
                elementID: ["usernameID"],
                is_Opt: 0,
                language: "cn",
                isEnabled: true,
                timeout: 3000,

                callback: (data) => {
                    this.form.captcha = data;
                    this.get_captcha();
                },
            };
            var nc = new noCaptcha(NC_Opt);
            nc.upLang("cn", {
                _startTEXT: "请按住滑块，拖动到最右边",
                _yesTEXT: "验证通过",
                _error300: '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
                _errorNetwork: '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>',
            });
        },
        methods: {
            get_captcha() {
                if (this.form.mobile == "") {
                    this.$alert("手机号码不能为空", "输入错误", {
                        confirmButtonText: "确定",
                        type: "error",
                        callback: (action) => {},
                    });
                } else if (this.form.captcha == "") {
                    this.$alert("请滑动验证码", "输入错误", {
                        type: "error",
                        confirmButtonText: "确定",
                        callback: (action) => {},
                    });
                } else if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.form.mobile)) {
                    this.$alert("手机号码格式错误", "输入错误", {
                        type: "error",
                        confirmButtonText: "确定",
                        callback: (action) => {},
                    });
                } else {
                    this.countDown = 60;
                    let loading_instance = this.$loading({
                        text: "正在发送验证码...",
                    });

                    this.$http
                        .post("auth/captcha/sms", {
                            mobile: this.form.mobile,
                            scope: "mobile_forgot",
                            captcha: this.form.captcha,
                        })
                        .then((response) => {
                            __nc.reset();

                            if (response.success) {
                                this.$alert("请查看手机短信验证码", "验证码发送成功", {
                                    confirmButtonText: "确定",
                                    type: "success",
                                });

                                this.step = 1;

                                // var timer = setInterval(() => {
                                //     this.countDown--;
                                //     if (this.countDown == 0) {
                                //         clearInterval(timer);
                                //     }
                                // }, 1000);
                            } else {
                                this.countDown = 0;
                                this.$alert(response.message, "验证码发送失败", {
                                    confirmButtonText: "确定",
                                    type: "error",
                                });
                            }
                        })
                        .catch(() => {
                            this.countDown = 0;
                        })
                        .then(() => {
                            loading_instance.close();
                        });
                }
            },
            onSubmit() {
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;

                        this.$http
                            .post("/auth/forgot_password", {
                                ...this.form,
                                scope: "mobile_forgot",
                            })
                            .then((response) => {
                                if (response.success) {
                                    this.step = 2;

                                    this.$router.push("/login");
                                } else {
                                    this.$alert(response.message, "错误", {
                                        showCancelButton: false,
                                        type: "error",
                                        confirmButtonText: "确定",
                                    });
                                }
                            })
                            .catch()
                            .then(() => {
                                this.submitting = false;
                            });
                    } else {
                        return false;
                    }
                });
            },
            resetForm() {
                this.$refs["form"].resetFields();
            },
        },
    };
</script>

<style scoped lang="less">
    .container {
        .w {
            height: calc(100vh - 290px);
            .step {
                margin: 48px auto;
                .el-steps {
                    max-width: 600px;
                    margin-left: auto;
                    margin-right: auto;
                }
            }

            .form {
                width: 415px;
                margin: 0 auto;
                .form-label-icon {
                    font-size: 18px;
                }
                .btn-sms,
                .btn-signup,
                .btn-reset {
                    display: block;
                    width: 100%;
                }
            }
        }
    }
</style>
